function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "AddBulkIcon",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3332 28.3327V31.666H29.9998C34.6022 31.666 38.3332 27.9351 38.3332 23.3327C38.3332 19.1409 35.2383 15.6721 31.2089 15.0864C29.7915 10.1754 25.2642 6.66602 19.9998 6.66602C16.0889 6.66602 12.5149 8.6078 10.3663 11.7498C5.44489 12.3885 1.6665 16.5973 1.6665 21.666C1.6665 27.1889 6.14366 31.666 11.6665 31.666V28.3327C7.9846 28.3327 4.99984 25.3479 4.99984 21.666C4.99984 18.0834 7.83207 15.1446 11.3993 15.0046L12.3176 14.9685L12.7772 14.1727C14.257 11.6101 16.9872 9.99935 19.9998 9.99935C24.085 9.99935 27.5504 12.9598 28.2181 16.9429L28.4561 18.363L29.8956 18.3337C29.9216 18.3333 29.9346 18.3331 29.9476 18.3329C29.9606 18.3328 29.9737 18.3328 29.9998 18.3327C32.7613 18.3327 34.9998 20.5713 34.9998 23.3327C34.9998 26.0941 32.7613 28.3327 29.9998 28.3327H28.3332ZM21.6666 34.9994V24.0231L25.488 27.8446L27.8451 25.4876L19.9999 17.6424L12.1547 25.4876L14.5117 27.8446L18.3332 24.0231V34.9994H21.6666Z",
  fill: "black"
});

var SvgCloudUpload = function SvgCloudUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloudUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud-upload.a9b814a1.svg";
export { ForwardRef as ReactComponent };